var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "add-user-port-window" },
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          ref: "dialog",
          attrs: {
            visible: _vm.visible,
            "close-on-click-modal": false,
            title: _vm.$t(
              "SystemMaintenance.PositionAssociatedRoutePortConfig"
            ),
            width: "970px"
          },
          on: {
            "update:visible": function($event) {
              _vm.visible = $event
            },
            close: _vm.removeHandler
          }
        },
        [
          _c(
            "div",
            { staticClass: "flex-column" },
            [
              _c("div", [
                _c("span", { staticClass: "title" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("SystemMaintenance.MatchingCriteriaSelection")
                    )
                  )
                ])
              ]),
              _c(
                "el-form",
                {
                  staticStyle: { "margin-top": "5px" },
                  attrs: { "label-width": "100px", inline: "" }
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.opOffice")))]
                      ),
                      _c("cargo-advance-select", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          "select-type":
                            _vm.selectTypeNames.basic_data_Office_All,
                          filterable: "",
                          multiple: true,
                          "static-options": _vm.officeList,
                          "default-multiple-value": _vm.toNumArray(
                            _vm.saveData.multipleOpOffice
                          ),
                          "tag-name": "code"
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.saveData.multipleOpOffice = _vm.toTxt(p.value)
                            _vm.onRelatedPrivilegeChange()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BusinessType")))]
                      ),
                      _c("cargo-advance-select", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          "select-type":
                            _vm.selectTypeNames
                              .local_cache_SystemConstants$LOBS,
                          "static-options": _vm.lobs,
                          "show-custom-label-in-option": true,
                          "default-value": _vm.saveData.lob,
                          clearable: false
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.ddlLobChangeHandler(p.value)
                            _vm.onRelatedPrivilegeChange()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BusinessModel")))]
                      ),
                      _c("cargo-advance-select", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          filterable: "",
                          multiple: true,
                          placeholder: " ",
                          "callback-method-type": "value",
                          "static-options": _vm.operateTypeList,
                          "default-multiple-value":
                            _vm.saveData.operateTypeList,
                          "tag-name": "chineseName",
                          "tag-value": "code"
                        },
                        on: {
                          parentCallBack: function(value) {
                            _vm.saveData.operateTypeList = [].concat(value)
                            _vm.onOperateTypeChange()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.CustomJobType")))]
                      ),
                      _c("cargo-advance-select", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          "select-type":
                            _vm.selectTypeNames.basic_data_CutomJobType,
                          filterable: "",
                          multiple: true,
                          "method-params": {
                            type: _vm.saveData.lob,
                            active: true
                          },
                          "default-multiple-value": _vm.toArray(
                            _vm.saveData.multipleCustomJobType
                          )
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.saveData.multipleCustomJobType = _vm.toTxt(
                              p.value
                            )
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("SystemMaintenance.PleaseSelectARoute")
                            )
                          )
                        ]
                      ),
                      _vm.isSea || _vm.isAir
                        ? _c("cargo-advance-select", {
                            staticStyle: { width: "200px" },
                            attrs: {
                              "select-type":
                                _vm.selectTypeNames.basic_data_Region,
                              "static-options": _vm.isSea
                                ? _vm.seaRegionList
                                : _vm.airRegionList,
                              filterable: "",
                              multiple: true,
                              "default-multiple-value": _vm.toArray(
                                _vm.saveData.multipleRegion
                              ),
                              "tag-name": "name"
                            },
                            on: { parentCallBack: _vm.onMultipleRegionChange }
                          })
                        : _c("cargo-advance-select", {
                            staticStyle: { width: "200px" },
                            attrs: {
                              "select-type":
                                _vm.selectTypeNames.basic_data_RailwayLine,
                              filterable: "",
                              multiple: true,
                              "default-multiple-value": _vm.toArray(
                                _vm.saveData.multipleRegion
                              ),
                              "tag-name": "name"
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.saveData.multipleRegion = _vm.toTxt(p.value)
                              }
                            }
                          })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      [
                        _vm.isAir
                          ? _c(
                              "div",
                              {
                                staticStyle: { "text-align": "center" },
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "SystemMaintenance.PleaseSelectLoadingPort"
                                    )
                                  )
                                )
                              ]
                            )
                          : _vm.isRailway
                          ? _c(
                              "div",
                              {
                                staticStyle: { "text-align": "center" },
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "SystemMaintenance.PleaseSelectOriginatingStation"
                                    )
                                  )
                                )
                              ]
                            )
                          : _c(
                              "div",
                              {
                                staticStyle: { "text-align": "center" },
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "SystemMaintenance.PleaseSelectDeparturePort"
                                    )
                                  )
                                )
                              ]
                            )
                      ],
                      [
                        _vm.isSea
                          ? _c("cargo-advance-select", {
                              staticStyle: { width: "200px" },
                              attrs: {
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Seaport,
                                "static-options": _vm.portList,
                                filterable: "",
                                multiple: true,
                                "callback-params": {
                                  key: "multipleLoadingPortCode"
                                },
                                "default-multiple-value": _vm.toArray(
                                  _vm.saveData.multipleLoadingPortCode
                                )
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.saveData[p.key] = _vm.toTxt(p.value)
                                }
                              }
                            })
                          : _vm.isAir
                          ? _c("cargo-advance-select", {
                              staticStyle: { width: "200px" },
                              attrs: {
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Airport,
                                "static-options": _vm.portList,
                                filterable: "",
                                multiple: true,
                                "callback-params": {
                                  key: "multipleLoadingPortCode"
                                },
                                "default-multiple-value": _vm.toArray(
                                  _vm.saveData.multipleLoadingPortCode
                                )
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.saveData[p.key] = _vm.toTxt(p.value)
                                }
                              }
                            })
                          : _c("cargo-advance-select", {
                              staticStyle: { width: "200px" },
                              attrs: {
                                "select-type":
                                  _vm.selectTypeNames.basic_data_RailwayStation,
                                filterable: "",
                                multiple: true,
                                "callback-params": {
                                  key: "multipleLoadingPortCode"
                                },
                                "default-multiple-value": _vm.toArray(
                                  _vm.saveData.multipleLoadingPortCode
                                )
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.saveData[p.key] = _vm.toTxt(p.value)
                                }
                              }
                            })
                      ]
                    ],
                    2
                  ),
                  _c(
                    "el-form-item",
                    [
                      [
                        _vm.isAir
                          ? _c(
                              "div",
                              {
                                staticStyle: { "text-align": "center" },
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "CargoMsg.Cargo_PortOfDestinationTip"
                                    )
                                  )
                                )
                              ]
                            )
                          : _vm.isRailway
                          ? _c(
                              "div",
                              {
                                staticStyle: { "text-align": "center" },
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "SystemMaintenance.PleaseSelectDestinationStation"
                                    )
                                  )
                                )
                              ]
                            )
                          : _c(
                              "div",
                              {
                                staticStyle: { "text-align": "center" },
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("CargoMsg.Cargo_PortOfDischargeTip")
                                  )
                                )
                              ]
                            )
                      ],
                      [
                        _vm.isSea
                          ? _c("cargo-advance-select", {
                              staticStyle: { width: "200px" },
                              attrs: {
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Seaport,
                                "static-options": _vm.portList,
                                filterable: "",
                                multiple: true,
                                "callback-params": { key: "code" },
                                "default-multiple-value": _vm.toArray(
                                  _vm.saveData.code
                                )
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.saveData[p.key] = _vm.toTxt(p.value)
                                }
                              }
                            })
                          : _vm.isAir
                          ? _c("cargo-advance-select", {
                              staticStyle: { width: "200px" },
                              attrs: {
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Airport,
                                "static-options": _vm.portList,
                                filterable: "",
                                multiple: true,
                                "callback-params": { key: "code" },
                                "default-multiple-value": _vm.toArray(
                                  _vm.saveData.code
                                )
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.saveData[p.key] = _vm.toTxt(p.value)
                                }
                              }
                            })
                          : _c("cargo-advance-select", {
                              staticStyle: { width: "200px" },
                              attrs: {
                                "select-type":
                                  _vm.selectTypeNames.basic_data_RailwayStation,
                                filterable: "",
                                multiple: true,
                                "callback-params": { key: "code" },
                                "default-multiple-value": _vm.toArray(
                                  _vm.saveData.code
                                )
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.saveData[p.key] = _vm.toTxt(p.value)
                                }
                              }
                            })
                      ]
                    ],
                    2
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.CargoType")))]
                      ),
                      _c("cargo-advance-select", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          "select-type":
                            _vm.selectTypeNames.basic_data_CargoType,
                          "method-params": _vm.isAir
                            ? { air: true }
                            : { sea: true },
                          filterable: "",
                          multiple: true,
                          "default-multiple-value": _vm.toArray(
                            _vm.saveData.multipleCargoType
                          )
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.saveData.multipleCargoType = _vm.toTxt(p.value)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("SystemMaintenance.PleaseSelectCarrier")
                            )
                          )
                        ]
                      ),
                      _vm.saveData.lob === "SE"
                        ? _c("cargo-company-select", {
                            attrs: {
                              "method-params": {
                                companyLob: "seaExport",
                                seaCmp: true,
                                active: true
                              },
                              multiple: "",
                              "default-multiple-value": _vm.toNumArray(
                                _vm.saveData.multipleCarrierId
                              ),
                              "custom-style": "width: 200px"
                            },
                            on: {
                              change: function(p) {
                                _vm.saveData.multipleCarrierId = _vm.toTxt(
                                  p.value
                                )
                              }
                            }
                          })
                        : _vm.saveData.lob === "SI"
                        ? _c("cargo-company-select", {
                            attrs: {
                              "method-params": {
                                companyLob: "seaImport",
                                seaCmp: true,
                                active: true
                              },
                              multiple: "",
                              "default-multiple-value": _vm.toNumArray(
                                _vm.saveData.multipleCarrierId
                              ),
                              "custom-style": "width: 200px"
                            },
                            on: {
                              change: function(p) {
                                _vm.saveData.multipleCarrierId = _vm.toTxt(
                                  p.value
                                )
                              }
                            }
                          })
                        : _vm.saveData.lob === "AE"
                        ? _c("cargo-company-select", {
                            attrs: {
                              "method-params": {
                                companyLob: "airExport",
                                airCmp: true,
                                active: true
                              },
                              multiple: "",
                              "default-multiple-value": _vm.toNumArray(
                                _vm.saveData.multipleCarrierId
                              ),
                              "custom-style": "width: 200px"
                            },
                            on: {
                              change: function(p) {
                                _vm.saveData.multipleCarrierId = _vm.toTxt(
                                  p.value
                                )
                              }
                            }
                          })
                        : _vm.saveData.lob === "AI"
                        ? _c("cargo-company-select", {
                            attrs: {
                              "method-params": {
                                companyLob: "airImport",
                                airCmp: true,
                                active: true
                              },
                              multiple: "",
                              "default-multiple-value": _vm.toNumArray(
                                _vm.saveData.multipleCarrierId
                              ),
                              "custom-style": "width: 200px"
                            },
                            on: {
                              change: function(p) {
                                _vm.saveData.multipleCarrierId = _vm.toTxt(
                                  p.value
                                )
                              }
                            }
                          })
                        : _vm.saveData.lob === "IE" &&
                          _vm.saveData.operateType.indexOf("IC") > -1
                        ? _c("cargo-company-select", {
                            attrs: {
                              "method-params": {
                                companyLob: "integratedJob",
                                truckCmp: true,
                                active: true
                              },
                              multiple: "",
                              "default-multiple-value": _vm.toNumArray(
                                _vm.saveData.multipleCarrierId
                              ),
                              "custom-style": "width: 200px"
                            },
                            on: {
                              change: function(p) {
                                _vm.saveData.multipleCarrierId = _vm.toTxt(
                                  p.value
                                )
                              }
                            }
                          })
                        : _c("el-select", {
                            staticStyle: { width: "200px" },
                            attrs: { disabled: "", value: "", placeholder: " " }
                          })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("CargoMsg.Cargo_PleaseSelectTheConsignee")
                            )
                          )
                        ]
                      ),
                      _c("cargo-company-select", {
                        attrs: {
                          no: "consigneeId",
                          "method-params": { consignee: true, active: true },
                          multiple: "",
                          "default-multiple-value":
                            _vm.saveData.multipleConsigneeIdList || [],
                          fields: ["englishName"],
                          "tag-name": "englishName",
                          "custom-style": "width: 200px"
                        },
                        on: {
                          change: function(p) {
                            _vm.saveData.multipleConsigneeIdList = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.SolicitationType")))]
                      ),
                      _c("cargo-advance-select", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          "select-type":
                            _vm.selectTypeNames.local_cache_CargoSource,
                          filterable: "",
                          multiple: true,
                          "default-multiple-value": _vm.toArray(
                            _vm.saveData.multipleCargoSource
                          )
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.saveData.multipleCargoSource = _vm.toTxt(
                              p.value
                            )
                          }
                        }
                      })
                    ],
                    1
                  ),
                  ["SE", "AE"].includes(_vm.saveData.lob)
                    ? _c(
                        "el-form-item",
                        [
                          _c(
                            "div",
                            {
                              staticStyle: { "text-align": "center" },
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_DestinationAgent")
                                )
                              )
                            ]
                          ),
                          _c("cargo-company-select", {
                            attrs: {
                              no: "consigneeId",
                              "method-params": {
                                overseaAgent: true,
                                active: true
                              },
                              multiple: "",
                              "default-multiple-value":
                                _vm.saveData.multipleDestinationAgentList || [],
                              fields: ["englishName"],
                              "tag-name": "englishName",
                              "custom-style": "width: 200px"
                            },
                            on: {
                              change: function(p) {
                                _vm.saveData.multipleDestinationAgentList =
                                  p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c("div", {
                staticStyle: {
                  width: "calc(100% + 20px)",
                  "margin-left": "-10px",
                  "margin-top": "10px",
                  "margin-bottom": "10px",
                  "border-top": "1px solid #E3E3E3"
                }
              }),
              _c("div", { staticStyle: { display: "flex" } }, [
                _c("div", { staticStyle: { width: "350px" } }, [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("SystemMaintenance.PresetValueConfiguration")
                      )
                    )
                  ])
                ])
              ]),
              _c(
                "el-form",
                {
                  staticStyle: { "margin-top": "5px" },
                  attrs: { "label-width": "100px", inline: "" }
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("SystemMaintenance.RelatedUser"))
                          )
                        ]
                      ),
                      _c("cargo-advance-select", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          "select-type": _vm.selectTypeNames.basic_data_User,
                          "callback-method-type": "value",
                          "default-value": _vm.saveData.userId,
                          filterable: "",
                          clearable: false
                        },
                        on: { parentCallBack: _vm.onUserIdChange }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-checkbox",
                        {
                          on: { change: _vm.onRelatedPrivilegeChange },
                          model: {
                            value: _vm.saveData.relatedPrivilege,
                            callback: function($$v) {
                              _vm.$set(_vm.saveData, "relatedPrivilege", $$v)
                            },
                            expression: "saveData.relatedPrivilege"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("SystemMaintenance.OptionalPositionsRoles")
                            )
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._l(_vm.positionData, function(position, i) {
                return _c(
                  "el-form",
                  { key: i, attrs: { "label-width": "100px", inline: "" } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: i === 0 ? "" : " " } },
                      [
                        i === 0
                          ? _c(
                              "div",
                              {
                                staticStyle: { "text-align": "center" },
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "SystemMaintenance.ResponsiblePosition"
                                    )
                                  )
                                )
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "200px" },
                            attrs: { filterable: "", clearable: "" },
                            on: {
                              change: function($event) {
                                return _vm.onPositionChange(position)
                              }
                            },
                            model: {
                              value: position.value,
                              callback: function($$v) {
                                _vm.$set(position, "value", $$v)
                              },
                              expression: "position.value"
                            }
                          },
                          _vm._l(_vm.roleList, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { label: item.name, value: item.code }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-checkbox",
                          {
                            model: {
                              value: position.isDefault,
                              callback: function($$v) {
                                _vm.$set(position, "isDefault", $$v)
                              },
                              expression: "position.isDefault"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_DefaultValue"))
                            )
                          ]
                        ),
                        i === 0 && _vm.allRole.length > _vm.positionData.length
                          ? _c(
                              "span",
                              {
                                staticClass: "form-operator",
                                on: { click: _vm.onAddPosition }
                              },
                              [_c("i", { staticClass: "el-icon-circle-plus" })]
                            )
                          : _c(
                              "span",
                              {
                                staticClass: "form-operator",
                                on: {
                                  click: function($event) {
                                    return _vm.onRemovePosition(position)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "el-icon-remove" })]
                            )
                      ],
                      1
                    )
                  ],
                  1
                )
              })
            ],
            2
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onSave } },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Save")))]
              ),
              _c("el-button", { on: { click: _vm.removeHandler } }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.Cancel")))
              ])
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }